import React, { useState } from "react";
import "./MediaFrame16x9.scss";

const ASPECT_RATIO_16_9 = 16 / 9;
const ASPECT_TOLERANCE = 0.01;

const MediaFrame16x9 = ({ src, alt = "Imagen", onClick }) => {
    const [isNativeAspect, setIsNativeAspect] = useState(false);

    const handleImageLoad = (event) => {
        const { naturalWidth, naturalHeight } = event.currentTarget;
        const imageAspect = naturalWidth / naturalHeight;
        setIsNativeAspect(Math.abs(imageAspect - ASPECT_RATIO_16_9) <= ASPECT_TOLERANCE);
    };

    return (
        <div className={`media-frame-16x9 ${isNativeAspect ? "is-native-aspect" : "has-blurred-background"}`}>
            <div
                className="media-frame-16x9-background"
                style={{ backgroundImage: `url("${src}")` }}
                aria-hidden="true"
            />
            <img src={src} alt={alt} onLoad={handleImageLoad} onClick={onClick} />
        </div>
    );
};

export default MediaFrame16x9;
